import React, { useState, useEffect, useRef } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import "../../css/main.css"

import { useAPICall } from '../../hooks/useAPICall.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageMenuElement } from '../elements/page_menu.js';

export function AdminPhotoForm() {
  const location = useLocation();
  const navigate = useNavigate();

  const [pageData, setPageData] = useState();
  const [memberData, setMemberData] = useState([]);
  const [imageData, setImageData] = useState();

  const { MakeCall } = useAPICall();

  let first_render = useRef(true);
  const handleDataFetch = (data) => {
    setPageData(data);
    LoadMemberImage(true);

  }
  if (first_render.current === true) {
    setMemberData(location.state.memberData);
    first_render.current = false;
  }

  useEffect(() => {
    LoadMemberImage(false);

  });
  function handleNav(destination, state) {
    navigate(destination, state);
  }

  function handlePhotoUpload() {
    var filesSelected = document.getElementById("inputFileToLoad").files;
    if (filesSelected.length > 0) {
      var fileToLoad = filesSelected[0];

      var fileReader = new FileReader();

      fileReader.onload = function (fileLoadedEvent) {
        var srcData = fileLoadedEvent.target.result; // <--- data: base64

        const postBody = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
          "\"memberid\" : \"" + location.state.memberData.idpeveril_member + "\", " +
          "\"image_data\":\"" + srcData + "\"}";

        MakeCall('admin/adminuploadimage', postBody, handleDataFetch, true);
      }
      fileReader.readAsDataURL(fileToLoad);
    }
  };

  const handleImageDataFetch = (data) => {
    setImageData(data.components['image_data']);
   
  }

  function LoadMemberImage(forceRead) {
    const postBody = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
      "\"memberid\" : \"" + location.state.memberData.idpeveril_member + "\"}";

    MakeCall('admin/adminloadimage', postBody, handleImageDataFetch, forceRead);
  }

  function ShowMemberImage() {
    let results = [];
    if (imageData) {
      results.push(<img alt='member' className='prcmemberimage' src={'data:image/jpeg;base64,' + imageData} key='memberimg'></img>)
    }
    return results;
  }
  function onPageMenuClick(onclickname) {
    switch (onclickname) {
        case 'goback':
           handleNav("/ViewMember", { state: { memberID: memberData.idpeveril_member } });
            break;        
        default:
            break;
  
    }

  }



  return (
    <div>
      {SecurityElement(pageData)}
      {MenuForm()}
      <div className="contentdiv">
      {PageMenuElement("Upload Photo", [{ "name": "Back", "onclick": "goback" }], onPageMenuClick)}
       

        <div className='formbox'>
          <div className='formtitle'>Details</div>
          <div style={{ "display": "flex", "verticalAlign": "middle" }}>
            <div style={{ "width": "100%" }}>
              <div className='formrow'>
                <div className='formlabel '>Number</div>
                <div className='formvalue'>{memberData.membership_number}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Type</div>
                <div className='formvalue'>{memberData.peveril_membership_type}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Forename</div>
                <div className='formvalue'>{memberData.forename}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Surname</div>
                <div className='formvalue'>{memberData.surname}</div>
              </div>
            </div>

          </div>
        </div>
        <div className='formbox'>
          <div className='formtitle'>New Photo</div>

          <div className='formrow'>
            <div className='formlabel'>File</div>

            <input type='file' className='loginfileinput' id='inputFileToLoad' />


          </div>
          <div className='formrowcentered'>
          <input type='button' className='prcbtn' value='Upload' onClick={handlePhotoUpload} />
          </div>

        </div>   
        <div className='formbox'>
          <div className='formtitle'>Photo</div>


          <div className='formrowcentered'>
          {ShowMemberImage()}   
          </div>

        </div>   

        
      </div>
    </div>




  );
}
